<ion-header>
  <ion-toolbar>
    <ion-title>PREGUNTAS ADICIONALES</ion-title>
    <ion-buttons slot="end">
      <ion-button color="dark" (click)="closeModal()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">

  <ng-container>
    <ion-card class="form-card" *ngFor="let activity of listActivities; let i = index">
      <ion-card-header>
        <ion-card-title>{{ activity.name }}</ion-card-title>
      </ion-card-header>
  
      <ion-card-content>
        <ng-container *ngIf="activity.additional_questions">
          <ion-item *ngFor="let item of activity.additional_questions">
            <ion-label position="floating">{{ item.label }}</ion-label>
            <ion-input [(ngModel)]="answers[i].answers_to_save[item.label]"
                       name="{{ item.label }}" autocomplete="off" 
                       [type]="item.question_type"
                       [min]="item.question_type === 'number' ? 1 : null"
                       [step]="item.question_type === 'number' ? 1 : null"
                       required>
              </ion-input>
          </ion-item>
        </ng-container>
  
      </ion-card-content>
    </ion-card>
    
    <div class="footer-submit-button">
      <ion-button 
      (click)="saveAnswersObject()"
      [disabled]="!areAllAnswersFilled()"
      >SUBIR RESPUESTAS</ion-button>
    </div>
  </ng-container>

</ion-content>